import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { SalePatternGridQuery, SalePatternGridQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalePatternGridQuery)
@Wrapper(SalePatternGridQueryHandlerBase)
export class SalePatternGridQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
